import { createRouter, createWebHashHistory, RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import layoutIndex from "@/layout/layoutIndex.vue";
import loginIndex from "@/layout/login/loginIndex.vue";
import workbenchIndex from "@/layout/workbench/workbenchIndex.vue";
import customerManage from "@/layout/customerManage/customerManage.vue";
import home from "./modules/home";
import store from "@/store";
import { Tag } from "@/store/modules/tag";
import { ElMessage } from "element-plus";
import manage from "./modules/manage";
import approve from "./modules/approve";
import customerManageNav from "./modules/customerManageNav";
import appStore from "./modules/appStore";
import inspection from "./modules/inspection";
import orderManagement from "@/views/orderManagement/orderManagement.vue";
import orderManagementItem from "./modules/orderManagement";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: layoutIndex,
    children: [
      {
        path: "/",
        name: "index",
        component: workbenchIndex,
        children: [...home],
      },
      {
        path: "/customerManage",
        name: "customerManage",
        component: customerManage,
        children: [...customerManageNav],
      },
      ...manage,
      ...approve,
      ...appStore,
      ...inspection,
      // 订单管理
      {
        path: "/orderManagement",
        name: "orderManagement",
        component: orderManagement,
        children: [...orderManagementItem],
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: loginIndex,
    meta: {
      title: "登录",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, form, next) => {
  const token = store.getters.getToken;
  if (to.query.Secret) {
    location.href = `${import.meta.env.VITE_BASE_PATH}?Secret=${to.query.Secret}#/login`;
    next();
    return;
  }
  if (!token && to.name != "login") {
    // debugger;
    const Secret = sessionStorage.getItem("Secret");
    const params = { name: "login", query: {} };
    if (Secret) {
      params.query = { Secret: Secret };
    }
    router.replace(params);
  } else if (!isCode(to)) {
    ElMessage({ message: "地址错误", type: "error" });
    // router.back();
  } else next();
});
router.beforeResolve((to, form, next) => {
  const tag: Tag = {
    label: String(to.meta.title),
    value: to.path,
    name: String(to.name),
    code: to.params.id,
  };
  store.commit("SET_TAG_CURRENT", tag);

  next();
});
/** 检查是否有当前企业号 */
function isCode(to: RouteLocationNormalized): boolean {
  const { id } = to.params;
  const codeArr = new Set(store.getters.getTagList.map((item: { code: string }) => item.code));
  console.log(codeArr, id, to);
  if (id) return codeArr.has(id);
  return true;
}
export default router;

export const getQueryVariable = (variable: string) => {
  const query = window.location.search.substring(1);
  console.log("🚀 ~ getQueryVariable ~ query:", query);
  const vars = query.split("&");
  console.log("🚀 ~ getQueryVariable ~ vars:", vars, variable);
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
};
